import { StyledContent } from '@/components/styles'
import { Picture } from '@/components'

const TitleContentImageBlock = ({ data }) => {
  const { content: htmlContent, image: imageFromProps, img_alt } = data
  const image = imageFromProps || {}
  const imageAlt = img_alt || '';

  return (
    <>
      {htmlContent && (
        <StyledContent.Description>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: htmlContent }} dark/>
        </StyledContent.Description>
      )}

      {Object.keys(image).length > 0 && (
        <StyledContent.Img>
          <Picture {...image} alt={imageAlt} isLazy={true} />
        </StyledContent.Img>
      )}
    </>
  )
}

export default TitleContentImageBlock
